import React from "react";
import { bool, string } from "prop-types";
import Image from "../Image";
import { Col, Row } from "../Grid";
import { classes } from "../utils/classes";

const BlockQuoteThumb = ({ className = "", src, alt = "", active = false, ...props }) => {
	return (
		<Col
			{...props}
			md="auto"
			className={classes("bq__item-thumb", active && "bq__item-thumb--active", className)}
		>
			<Row utility={{ align: { items: "center" } }} className="bq__item-thumb-wrapper">
				<Col>
					<Image src={src} alt={alt} />
				</Col>
			</Row>
		</Col>
	);
};

BlockQuoteThumb.propTypes = {
	src: string.isRequired,
	alt: string,
	active: bool,
	className: string,
};

export default BlockQuoteThumb;
